/**
 * Formatação de dinheiro e o mascaramento do olhinho.
 *
 * `MASKED_VALUE` vivia solto dentro de `App.tsx`, então qualquer componente que
 * quisesse respeitar o botão de ocultar valores teria que recriar a string. Duas
 * cópias de um mascaramento divergem em silêncio: uma vira `••••••` e a outra
 * `•••••`, e ninguém percebe até ver as duas na mesma tela.
 */

export const MASKED_VALUE = '••••••';

export const formatBRL = (v: number, opcoes?: Intl.NumberFormatOptions): string =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', ...opcoes }).format(v);

/**
 * Valor formatado, ou os pontinhos quando o olhinho está fechado.
 *
 * É por AQUI que o botão "Ocultar valores" alcança a tela inteira. Antes cada
 * seção montava o próprio `Intl.NumberFormat` — eram NOVE cópias em sete
 * componentes — e como não havia um lugar por onde todo dinheiro passasse, o
 * olhinho só conseguia esconder os quatro cartões do topo.
 */
export const brlOrMasked = (
  v: number,
  hidden: boolean,
  opcoes?: Intl.NumberFormatOptions,
): string => (hidden ? MASKED_VALUE : formatBRL(v, opcoes));

/**
 * Porcentagem em pt-BR.
 *
 * Havia NOVE `toFixed(1)` espalhados por Goals, CategoryChart, Investments e
 * PaymentMethods, e `toFixed` escreve ponto: o cartão do Nubank dizia
 * "Faltam R$ 2.086,00 (69.5%)" — vírgula e ponto na mesma frase, sobre o mesmo
 * dinheiro. É a armadilha 4 na forma mais barata de aparecer: nove cópias de
 * "como se escreve um número", nenhuma delas a certa, e nenhuma quebrando nada
 * quando diverge.
 *
 * `max` acima de `min` deixa a casa extra aparecer só quando existe — taxa de
 * investimento precisa de 0,4868%, e cortar em duas casas mentiria sobre o
 * rendimento.
 */
export const formatPct = (v: number, min = 1, max = min): string =>
  v.toLocaleString('pt-BR', { minimumFractionDigits: min, maximumFractionDigits: max }) + '%';
